import React, { Component } from "react";
import "./assets/feature.scss";

export default class Highlights extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="row">
          <div className="col-md-4 col-lg-4 col-sm-6 col-xs-12">
              <div className="promo">
                  <div className="promo-icon"><i className="fas fa-comment-medical"></i></div>
                  <div className="promo-details">
                      <h3>Information</h3>
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                  </div>
              </div>
              <div className="promo">
                  <div className="promo-icon"><i className="fas fa-peace"></i></div>
                  <div className="promo-details">
                      <h3>Meditation</h3>
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                  </div>
              </div>
          </div>
          <div className="col-md-4 col-lg-4 col-sm-6 col-xs-12">
              <div className="promo">
                  <div className="promo-icon"><i className="fas fa-gamepad"></i></div>
                  <div className="promo-details">
                      <h3>Games</h3>
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                  </div>
              </div>
              <div className="promo">
                  <div className="promo-icon"><i className="fab fa-app-store"></i></div>
                  <div className="promo-details">
                      <h3>Apps</h3>
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                  </div>
              </div>
          </div>
          <div className="col-md-4 col-lg-4 col-sm-6 col-xs-12">
              <div className="promo">
                  <div className="promo-icon"><i className="fas fa-bed"></i></div>
                  <div className="promo-details">
                      <h3>Sleep</h3>
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                  </div>
              </div>
              <div className="promo">
                  <div className="promo-icon"><i className="fas fa-dumbbell"></i></div>
                  <div className="promo-details">
                      <h3>Exercise</h3>
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                  </div>
              </div>
          </div>
      </div>
    );

  }

}



// WEBPACK FOOTER //
// ./src/containers/main/features/Highlights.js